<template>
    <div>
        <div class="af-job-apply-header">
            <div class="af-job-apply-header-info afu-mb-12 md:afu-mb-10 afu-flex afu-items-center afu-leading-8">
                <div
                    v-if="$_jobApplication.apply_step===1 || $_isApplyAsExistingUser"
                    class="af-job-apply-header-title af-text--2xl afu-font-semibold afu-text-dark-900"
                >
                    {{ $t('apply.job_application') }}
                </div>
                <a
                    v-else
                    @click.stop.prevent="closeApplyForm()"
                    class="af-back-link afu-text-primary afu-no-underline"
                    href="#"
                >
                    <FontAwesomeIcon
                        :icon="['far', 'chevron-left']"
                        size="xs"
                        class="afu-mr-2 md:afu-mr-3"
                    />
                    <span class="afu-text-lg md:afu-text-xs">{{ $t('label.back') }}</span>
                </a>
                <div
                    v-if="!$_isApplyAsExistingUser" 
                    class="af-job-apply-steps afu-ml-auto afu-text-right"
                >
                    <span
                        v-if="$_jobApplication.apply_steps_count > 0"
                        class="af-job-apply-steps-info afu-text-5xl afu-uppercase afu-text-neutral-dark afu-tracking-widest"
                    >
                        Step {{ $_jobApplication.apply_step }} of {{ $_jobApplication.apply_steps_count }}
                    </span>
                    <div class="af-job-apply-progress-bar afu-w-full">
                        <div class="afu-w-full afu-bg-neutral afu-rounded-full">
                            <div
                                class="afu-bg-secondary afu-text-xs afu-h-1 afu-text-center afu-text-white afu-rounded-full"
                                :style="`width: ${progressPercentage}%;`"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapGetters } from 'vuex';

    export default {
        name: 'ApplyHeader',

        data() {
            return {};
        },

        computed: {
            ...mapState({
                $_jobApplication: state => state.jobApplication,
                $_job: state => state.job.job,
            }),

            ...mapGetters('jobApplication', {
                $_isApplyAsExistingUser: 'isApplyAsExistingUser',
            }),

            progressPercentage() {
                let percentageValue = 0;
                percentageValue =  (this.$_jobApplication.apply_step / this.$_jobApplication.apply_steps_count) * 100;
                return percentageValue;
            },
        },
        methods: {
            ...mapMutations('jobApplication', {
                $_RESET_APPLY: 'RESET_APPLY',
            }),

            closeApplyForm() {
                this.$_RESET_APPLY();
                // window.location.href = `/apply/${this.$_job.category_slug}/${this.$_job.uuid}`;
            },
        },
    };
</script>
